var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisibilityPass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_94",
    "data-name": "Groupe 94",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_92",
    "data-name": "Trac\\xE9 92",
    d: "M23.5,20.75A2.75,2.75,0,1,1,20.75,18,2.752,2.752,0,0,1,23.5,20.75Z",
    transform: "translate(-9.75 -9.75)",
    fill: "none",
    stroke: "#088168",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_93",
    "data-name": "Trac\\xE9 93",
    d: "M4.92,16.417a9.167,9.167,0,0,1,17.49,0,9.167,9.167,0,0,1-17.49,0Z",
    transform: "translate(-2.665 -5.417)",
    fill: "none",
    stroke: "#088168",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_94",
    "data-name": "Trac\\xE9 94",
    d: "M0,0H22V22H0Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityPass);
export default __webpack_public_path__ + "static/media/visibilityPass.bb4157642a3872b3042a3e919870ba4d.svg";
export { ForwardRef as ReactComponent };